import api from './api'
import http from '@sinolink/http'
import { WechatAuthOptions, WechatUserInfoOptions } from '../types/WehatAccountTypes'

/**
 * 获取授权地址
 */
export function getWechatAuthUrl(params: WechatAuthOptions) {
  return http.get(api.getWechatAuth, {
    params
  })
}

/**
 *  获取微信用户信息
 * @param data
 * @returns
 */
export function getWechatUserInfoService(params: WechatUserInfoOptions) {
  return http.get(api.getWechatUserInfo, { params })
}
